// import React, { useEffect, useState } from "react";
// import { Link, useNavigate, useLocation } from "react-router-dom";
// import cartImg from "../assets/Images/cart.png";
// import searchImg from "../assets/Images/search.png";
// import logoImg from "../assets/Images/img6.png";
// import UserImage from "../assets/Images/user.png";
// import NavIcon from "../assets/Images/navicon.png";
// import whitebar from "../assets/Images/whitebarger.png";
// import Service from "services/service";
// import { globalStore } from "stores/globalStore";
// import whiteNav from "../assets/Images/img6.png";

// import whiteCart from "../assets/Images/cartWhite.png";
// import whiteUser from "../assets/Images/Userwhite.png";

// const Navbar = () => {
//   const {
//     setCartCount,
//     cartCount,
//     setDarkMode,
//     darkMode,
//     productOverviewData,
//   } = globalStore();
//   const navigate = useNavigate();
//   const location = useLocation();
//   const [isToggled, setIsToggled] = useState(false);
//   const [isMobile, setIsMobile] = useState(false);
//   const [isModeToggled, setIsModeToggled] = useState(false);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [suggestions, setSuggestions] = useState([]);
//   const [showSuggestions, setShowSuggestions] = useState(false);

//   useEffect(() => {
//     const savedDarkMode = localStorage.getItem("darkMode") === "true";
//     setDarkMode(savedDarkMode);
//     setIsModeToggled(savedDarkMode);
//     document.documentElement.setAttribute(
//       "data-theme",
//       savedDarkMode ? "dark" : "light"
//     );
//   }, [setDarkMode]);

//   const handleModeToggle = () => {
//     const newDarkMode = !darkMode;
//     setDarkMode(newDarkMode);
//     setIsModeToggled(newDarkMode);
//     localStorage.setItem("darkMode", String(newDarkMode));
//     document.documentElement.setAttribute(
//       "data-theme",
//       newDarkMode ? "dark" : "light"
//     );
//   };

//   useEffect(() => {
//     const handleCartCount = async () => {
//       try {
//         const response = await Service.getCartCount();
//         setCartCount(response.data.data.count);
//       } catch (error) {
//         console.error("Error fetching cart count:", error);
//       }
//     };

//     handleCartCount();
//   }, [setCartCount]);

//   useEffect(() => {
//     const handleResize = () => {
//       setIsMobile(window.innerWidth <= 1050);
//     };

//     window.addEventListener("resize", handleResize);
//     handleResize();

//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   useEffect(() => {
//     setIsToggled(false);
//   }, [location]);

//   useEffect(() => {
//     if (searchQuery.trim()) {
//       const filteredSuggestions = productOverviewData.filter((product) =>
//         product.name.toLowerCase().includes(searchQuery.toLowerCase())
//       );
//       setSuggestions(filteredSuggestions);
//       setShowSuggestions(true);
//     } else {
//       setSuggestions([]);
//       setShowSuggestions(false);
//     }
//   }, [searchQuery, productOverviewData]);

//   const handleSearchChange = (e) => {
//     let value = e.target.value;
//     if (value.includes(",")) {
//       value = value.split(",")[0];
//     }
//     setSearchQuery(value);
//   };

//   const handleSearchSubmit = async (e) => {
//     e.preventDefault();
//     if (searchQuery.trim()) {
//       try {
//         const response = await Service.searchProducts(searchQuery.trim());
//         navigate("/productlisting", { state: { searchResults: response.data } });
//       } catch (error) {
//         console.error("Error searching products:", error);
//       }
//     }
//   };

//   const handleSuggestionClick = async (product) => {
//     setSearchQuery(product.name);
//     setShowSuggestions(false);

//     try {
//       const response = await Service.searchProducts(product.name);
//       navigate("/productlisting", { state: { searchResults: response.data } });
//     } catch (error) {
//       console.error("Error searching products:", error);
//     }
//   };

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (event.target.closest(".suggestions-dropdown") === null) {
//         setShowSuggestions(false);
//       }
//     };

//     document.addEventListener("mousedown", handleClickOutside);
//     return () => {
//       document.removeEventListener("mousedown", handleClickOutside);
//     };
//   }, []);

//   return (
   
//     <div>
//   <div className="header__bottom-section">
//     <div className="header__logo-row">

//       {/* ✅ Logo + Text */}
//       <div className="logo-with-text" onClick={() => navigate("/")}>
//         <img
//           src={darkMode ? whiteNav : logoImg}
//           alt="Header Logo"
//           className="header__logo"
//         />
//         <span className="brand-text">Rekha Collection</span>
//       </div>

//       {isMobile && (
//         <div
//           className={`hamburger-icon ${isToggled ? "toggled" : ""}`}
//           onClick={() => setIsToggled(!isToggled)}
//         >
//           <img
//             src={darkMode ? whitebar : NavIcon}
//             alt="Menu Icon"
//             className="nav-icon"
//           />
//         </div>
//       )}

//       <div
//         className={`header__navigation-row ${
//           isMobile && !isToggled ? "hidden" : "show"
//         }`}
//       >
//         <div className="header__menu-row">
//           <ul className="header__menu">
//             <li>
//               <Link
//                 to="/productlisting"
//                 className={`header__menu-item ${
//                   location.pathname === "/productlisting"
//                     ? "active-tab"
//                     : ""
//                 }`}
//               >
//                 <p className="header__menu-item--most-wanted ui text size-text2xl">
//                   Home
//                 </p>
//               </Link>
//             </li>

//             {/* <li>
//               <Link
//                 to="/combos"
//                 className={`header__menu-item ${
//                   location.pathname === "/combos" ? "active-tab" : ""
//                 }`}
//               >
//                 <p className="header__menu-item--most-wanted ui text size-text2xl">
//                   Combos
//                 </p>
//               </Link>
//             </li> */}

//             {/* <li>
//               <Link
//                 to="/wanted"
//                 className={`header__menu-item ${
//                   location.pathname === "/wanted" ? "active-tab" : ""
//                 }`}
//               >
//                 <p className="header__menu-item--most-wanted ui text size-text2xl">
//                   Most Wanted
//                 </p>
//               </Link>
//             </li> */}

//             {/* <li>
//               <Link
//                 to="/addition"
//                 className={`header__menu-item ${
//                   location.pathname === "/addition" ? "active-tab" : ""
//                 }`}
//               >
//                 <p className="header__menu-item--most-wanted ui text size-text2xl">
//                   New Additions
//                 </p>
//               </Link>
//             </li> */}
//               <Link
//                 to="/About"
//                 className={`header__menu-item ${
//                   location.pathname === "/About" ? "active-tab" : ""
//                 }`}
//               >
//                 <p className="header__menu-item--most-wanted ui text size-text2xl">
//                   About Us
//                 </p>
//               </Link>
//           </ul>
//         </div>

//         <div className="header__actions-row">
//           <div className="searchUpper-class">
//             <form
//               onSubmit={handleSearchSubmit}
//               className="header__search ui input gray_50 size-sm fill round"
//             >
//               <img src={searchImg} alt="Search Icon" className="loupe-1" />
//               <input
//                 name="Search Field"
//                 placeholder="Search your need"
//                 type="text"
//                 value={searchQuery}
//                 onChange={handleSearchChange}
//               />

//               {showSuggestions && suggestions.length > 0 && (
//                 <div className="suggestions-dropdown">
//                   {suggestions.map((product) => (
//                     <div
//                       key={product.id}
//                       className="suggestion-item"
//                       onClick={() => handleSuggestionClick(product)}
//                     >
//                       <img
//                         src={product.primaryImage}
//                         alt={product.name}
//                         className="suggestion-image"
//                       />
//                       <div className="suggestion-details">
//                         <span className="suggestion-name">
//                           {product.name}
//                         </span>
//                         <span className="suggestion-category">
//                           {product.category}
//                         </span>
//                       </div>
//                     </div>
//                   ))}
//                 </div>
//               )}
//             </form>
//           </div>

//           <div className="icons_action">
//             <Link to="/Cart" className="header__cart-container">
//               <img
//                 src={darkMode ? whiteCart : cartImg}
//                 alt="Cart Icon"
//                 className="header__cart"
//               />
//               <span className="cartCount">{cartCount}</span>
//             </Link>

//             <Link to="/UserProfile">
//               <img src={darkMode ? whiteUser : UserImage} alt="User" />
//             </Link>

//             <div className="header__toggle-container">
//               <div
//                 className={`toggle-switch ${isModeToggled ? "toggled" : ""}`}
//                 onClick={handleModeToggle}
//               >
//                 <div className="toggle-ball" />
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   </div>
// </div>
//   );
// };

// export default Navbar;

import React, { useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import cartImg from "../assets/Images/cart.png";
import searchImg from "../assets/Images/search.png";
import logoImg from "../assets/Images/img6.png";
import UserImage from "../assets/Images/user.png";
import NavIcon from "../assets/Images/navicon.png";
import whitebar from "../assets/Images/whitebarger.png";
import whiteCart from "../assets/Images/cartWhite.png";
import whiteUser from "../assets/Images/Userwhite.png";
import Service from "services/service";
import { globalStore } from "stores/globalStore";

const Navbar = () => {
  const {
    setCartCount,
    cartCount,
    setDarkMode,
    darkMode,
    productOverviewData,
  } = globalStore();
  const navigate = useNavigate();
  const location = useLocation();
  const [isToggled, setIsToggled] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [isModeToggled, setIsModeToggled] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);

  useEffect(() => {
    const savedDarkMode = localStorage.getItem("darkMode") === "true";
    setDarkMode(savedDarkMode);
    setIsModeToggled(savedDarkMode);
    document.documentElement.setAttribute(
      "data-theme",
      savedDarkMode ? "dark" : "light"
    );
  }, [setDarkMode]);

  const handleModeToggle = () => {
    const newDarkMode = !darkMode;
    setDarkMode(newDarkMode);
    setIsModeToggled(newDarkMode);
    localStorage.setItem("darkMode", String(newDarkMode));
    document.documentElement.setAttribute(
      "data-theme",
      newDarkMode ? "dark" : "light"
    );
  };

  useEffect(() => {
    const handleCartCount = async () => {
      try {
        const response = await Service.getAllCartData();
        const items = response.data.data?.items || [];
        setCartCount(items.length);
      } catch (error) {
        console.error("Error fetching cart count:", error);
      }
    };

    handleCartCount();
  }, [setCartCount]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1050);
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    setIsToggled(false);
  }, [location]);

  useEffect(() => {
    if (searchQuery.trim()) {
      const filteredSuggestions = productOverviewData.filter((product) =>
        product.name.toLowerCase().includes(searchQuery.toLowerCase())
      );
      setSuggestions(filteredSuggestions);
      setShowSuggestions(true);
    } else {
      setSuggestions([]);
      setShowSuggestions(false);
    }
  }, [searchQuery, productOverviewData]);

  const handleSearchChange = (e) => {
    let value = e.target.value;
    if (value.includes(",")) {
      value = value.split(",")[0];
    }
    setSearchQuery(value);
  };

  const handleSearchSubmit = async (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      try {
        const response = await Service.searchProducts(searchQuery.trim());
        navigate("/productlisting", { state: { searchResults: response.data } });
      } catch (error) {
        console.error("Error searching products:", error);
      }
    }
  };

  const handleSuggestionClick = async (product) => {
    setSearchQuery(product.name);
    setShowSuggestions(false);

    try {
      const response = await Service.searchProducts(product.name);
      navigate("/productlisting", { state: { searchResults: response.data } });
    } catch (error) {
      console.error("Error searching products:", error);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (event.target.closest(".suggestions-dropdown") === null) {
        setShowSuggestions(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div>
      <div className="header__bottom-section">
        <div className="header__logo-row">
          {/* Logo + Text */}
          <div className="logo-with-text" onClick={() => navigate("/")}>
            <img
              src={logoImg}
              alt="Header Logo"
              className="header__logo"
            />
            <div className="brand-info">
              <span className="brand-text">Rekha Collection</span>
              <span className="brand-tagline">সবার জন্য সাধ্যের মধ্যে</span>
            </div>
          </div>

          {isMobile && (
            <div
              className={`hamburger-icon ${isToggled ? "toggled" : ""}`}
              onClick={() => setIsToggled(!isToggled)}
            >
              <img
                src={darkMode ? whitebar : NavIcon}
                alt="Menu Icon"
                className="nav-icon"
              />
            </div>
          )}

          <div
            className={`header__navigation-row ${
              isMobile && !isToggled ? "hidden" : "show"
            }`}
          >
            <div className="header__menu-row">
              <ul className="header__menu">
                <li>
                  <Link
                    to="/productlisting"
                    className={`header__menu-item ${
                      location.pathname === "/productlisting"
                        ? "active-tab"
                        : ""
                    }`}
                  >
                    <p className="header__menu-item--most-wanted ui text size-text2xl">
                      Home
                    </p>
                  </Link>
                </li>

                <li>
                  <Link
                    to="/About"
                    className={`header__menu-item ${
                      location.pathname === "/About" ? "active-tab" : ""
                    }`}
                  >
                    <p className="header__menu-item--most-wanted ui text size-text2xl">
                      About Us
                    </p>
                  </Link>
                </li>
              </ul>
            </div>

            <div className="header__actions-row">
              <div className="searchUpper-class">
                <form
                  onSubmit={handleSearchSubmit}
                  className="header__search ui input gray_50 size-sm fill round"
                >
                  <img src={searchImg} alt="Search Icon" className="loupe-1" />
                  <input
                    name="Search Field"
                    placeholder="Search your need"
                    type="text"
                    value={searchQuery}
                    onChange={handleSearchChange}
                  />

                  {showSuggestions && suggestions.length > 0 && (
                    <div className="suggestions-dropdown">
                      {suggestions.map((product) => (
                        <div
                          key={product.id}
                          className="suggestion-item"
                          onClick={() => handleSuggestionClick(product)}
                        >
                          <img
                            src={product.primaryImage}
                            alt={product.name}
                            className="suggestion-image"
                          />
                          <div className="suggestion-details">
                            <span className="suggestion-name">
                              {product.name}
                            </span>
                            <span className="suggestion-category">
                              {product.category}
                            </span>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </form>
              </div>

              <div className="icons_action">
                <Link to="/Cart" className="header__cart-container">
                  <img
                    src={darkMode ? whiteCart : cartImg}
                    alt="Cart Icon"
                    className="header__cart"
                  />
                  <span className="cartCount">{cartCount}</span>
                </Link>

                <Link to="/UserProfile">
                  <img src={darkMode ? whiteUser : UserImage} alt="User" />
                </Link>

                <div className="header__toggle-container">
                  <div
                    className={`toggle-switch ${isModeToggled ? "toggled" : ""}`}
                    onClick={handleModeToggle}
                  >
                    <div className="toggle-ball" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Navbar;